export default __webpack_public_path__ + "src/images/packages/the-african-renaissance/3a2aa61b839fb5fb8f37a385e8a2ac30-4.jpg";